import { arrayOf } from 'prop-types';

import { goalShape } from '@/components/GoalTiles/shapes';

const goalsShape = arrayOf(goalShape);

export default goalsShape;
